module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_2.766766c4.png";